module.exports = __webpack_public_path__ + "assets/img/thumb_ch2-item-1.6c460e47.jpg";